<template>
    <div style="width: 100px; margin-right: 15px">
        <b-form-select :value="$store.state.year" @change="onChange" :options="yearOptions" :class="this.variant == 'light' ? 'white-select' : 'gray-select'" style="height:41px !important;"/>
    </div>
</template>

<script>
export default {
    name: 'YearSelect',
    props: {
        variant: {
            type: String,
            default(){
                return null
            }
        },
    },
    methods: {
        onChange(val) {
            this.$emit('onchange', val);
        }
    }
};
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/YearSelect.vue